import { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { freeWheelApi } from '../../api/freeWheelApi/freeWheelApi';
import { isOptanonClosed } from '../../helpers/oneTrustBanner';
import { useTranslations } from '../../hooks/useTranslations';
import { deviceInfoSelector } from '../../store/deviceInfo';
import { useEnv } from '../EnvProvider/EnvProvider';
import { BREAKPOINT } from '../ThemeProvider/constants/breakpoints';
import * as UI from './SponsorLogo.styles';

const SponsorLogo = () => {
  const t = useTranslations();
  const [showSponsorLogo, setShowSponsorLogo] = useState(false);
  const { SPONSOR_LOGO_URL_L, SPONSOR_LOGO_URL_S, FREEWHEEL_API_URL } = useEnv();
  const { deviceId } = useSelector(deviceInfoSelector);

  /*
      This event is triggered when:
      1. An asset isn't available, for example, due to a request status of 404, 
         but only once <img /> is rendered.
      2. When an asset is available during a rendering of <img />.
      3. When an asset becomes available during a resizing of a browser window.
     
      This event isn't triggered when:
      1. An asset isn't available during the resizing of a browser window, 
         for example, due to a request status of 404. There is no accepted way to handle that case.
    */

  const onLoadImgHandler = useCallback(
    (state: boolean) => () => {
      setShowSponsorLogo(state);
    },
    [],
  );

  useEffect(() => {
    if (isOptanonClosed()) {
      showSponsorLogo && freeWheelApi.trackSponsorLogo({ apiUrl: FREEWHEEL_API_URL, deviceId });
    }
  }, [showSponsorLogo]);

  return (
    <UI.SponsorLogoWrapper $visibility={showSponsorLogo}>
      <UI.SponsorLogoLabel>{t.sponsor_logo_label}</UI.SponsorLogoLabel>
      <picture>
        <source srcSet={SPONSOR_LOGO_URL_L} media={`(min-width: ${BREAKPOINT.lg}px)`} />
        <UI.SponsorLogoImg
          src={SPONSOR_LOGO_URL_S}
          alt={t.sponsor_logo_alt}
          onError={onLoadImgHandler(false)}
          onLoad={onLoadImgHandler(true)}
        />
      </picture>
    </UI.SponsorLogoWrapper>
  );
};

export default SponsorLogo;
